import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FieldArray } from 'redux-form';
import cn from 'classname';
import noop from 'lodash/noop';
import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import AddField from './add-field';
import Entity from './entity';

const Form = (props) => (
	<div className="individual-terms">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.alertsFormSubmit(data))}>
			<FieldArray name="alerts" {...props} component={RenderFieldArray} />
			<div className="ui-form__element individual-terms__buttons-wrap">
				<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
			</div>
		</form>
	</div>
);

const RenderFieldArray = (props) => (
	<div className="entity-wrap">
		<AddField
			{...props}
			disabled={shouldDisabledAddField(props.fields.getAll())}
			onClick={() => props.fields.push({})} />

		{props.fields.length > 0 && (
			<table className="entity-wrap__table">
				<thead className="entity-wrap__table-head">
					<tr>
						<th className="name">Campaign</th>
						<th className="creation">Creation date</th>
						<th className="closing">Closing date</th>
						<th className="count">Count of weeks</th>
						<th className="actions">Deactivate alert</th>
					</tr>
				</thead>
				<tbody className="entity-wrap__table-body">
					{(props.fields.map((parentName, index, fields) => {
						const res = [];
						const shouldShowTarget = props.listOfActivePanIndex.indexOf(index) > -1;
						const onToggleTargetPan = props.savedTerms[index]
							? shouldShowTarget
								? props.termsHideTargets
								: handleTermsShowTarget(
									props.savedTerms[index],
									props.termsShowTargets,
									props.fetchOfferDefaultTarget
								)
							: noop;

						// offers row
						res.push(<Entity
							className={cn({
								'is-show-target': shouldShowTarget,
								'stopped-alert': get(props.savedTerms, `${index}.alert[0].removed_at`, false)
							})}
							type='alert'
							parentName={parentName}
							index={index}
							intl={props.intl}
							placeholder={props.intl('Select Alert')}
							entityLookup={props.alertsLookups}
							savedTerms={props.savedTerms}
							fields={props.fields}
							selectedCurrenciesPanIndexMap={props.selectedCurrenciesPanIndexMap}
							onRemoveField={props.removeTerms}
							onToggleTargetPan={onToggleTargetPan}
							onFetchDefaultTarget={props.fetchOfferDefaultTarget}
							onChangeCurrency={props.changeCurrency}
							onDeleteAlerts={props.deleteAlerts}
							isMaster={props.isMaster} />);
						return res;
					})).reverse()}
				</tbody>
			</table>
		)}
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	alertsFormSubmit: PropTypes.func,
	intl: PropTypes.func
};

RenderFieldArray.propTypes = {
	fields: PropTypes.object,
	intl: PropTypes.func,
	offersLookups: PropTypes.func,
	removeTerms: PropTypes.func,
	termsResetToDefault: PropTypes.func,
	nullifiedBoosts: PropTypes.array,
	indTermsNullifyBoostOnSubmit: PropTypes.func,
	isMaster: PropTypes.bool
};

// functions
const shouldDisabledAddField = fields => {
	if (!fields) return true;
	return !!find(fields, entity => isEmpty(entity));
};

const handleTermsShowTarget = (entity, onShowTermsPane, onFetchDefaultTarget) => (index) => {
	const offer = entity.offer[0];
	onFetchDefaultTarget(index, offer, true);
};

export default reduxForm({
	form: 'affiliateIndividualAlertsForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/alerts/main.js